import React, { useState } from "react";

import { Box, Typography } from "@mui/material";

import CrmSourceMappingArea from "components/CrmSourceMappingArea";
import AllSourceEditMappings from "components/sourceEditMappings/AllSourceEditMappings";
import SourceMappingArea from "components/SourceMappingArea";
import SwalAlertComp from "components/SwalAlert";

import { TabProps } from "../../../SourceModal.types";

const EditMappingTab: React.FC<TabProps> = ({
    source,
    tracker,
    language,
    onRefresh,
    onClose,
}) => {
    const sourceCode = source?.source_type?.code;
    const [showMappingComponent, setShowMappingComponent] = useState(true);

    const handleMappingSuccess = () => {
        SwalAlertComp({
            title: language?.delete_swal_modal?.success ?? "Success",
            message: "Mapping updated successfully",
            icon: "success",
        });
        onRefresh();
    };

    const getMappingComponent = () => {
        const crmSources = [
            "zoho",
            "hub",
            "salesforce",
            "dynamics",
            "zendesk_sell",
            "pipe",
            "b24",
            "freshsales",
            "vtiger",
            "odoo",
            "lsqrd",
            "monday",
        ];

        if (crmSources.includes(sourceCode || "")) {
            return (
                <CrmSourceMappingArea
                    sourceId={source?.id}
                    sourceType={sourceCode}
                    mappingSuccess={handleMappingSuccess}
                    isEditMapping={true}
                    closeButtonHidden={true}
                    closeModal={onClose}
                />
            );
        }

        const sourceMappingTypes = [
            "upload",
            "ftp",
            "sftp",
            "spreadsheet",
            "bigquery",
            "appsflyer",
            "adjust",
        ];

        if (sourceMappingTypes.includes(sourceCode || "")) {
            return (
                <SourceMappingArea
                    sourceId={source?.id}
                    sourceType={sourceCode}
                    isEditMapping={true}
                    mappingSuccess={handleMappingSuccess}
                    closeButtonHidden={true}
                    closeModal={onClose}
                    isModal={false}
                />
            );
        }

        return (
            <AllSourceEditMappings
                ftpMappingId={source?.id}
                setAllSourceMapping={handleMappingSuccess}
                allSourceMapping={{}}
                setShowFtpMapping={setShowMappingComponent}
                mappingSourceCode={sourceCode}
            />
        );
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                {language?.buttons?.edit_mapping ?? "Edit Mapping"}
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
                Configure how data fields from your source map to destination
                events.
            </Typography>

            <Box sx={{ mt: 2 }}>{getMappingComponent()}</Box>
        </Box>
    );
};

export default EditMappingTab;
